/**
 * ContratosPendentesWidget — quantos contratos esperam assinatura.
 *
 * Permissao: contrato:view. Fonte: GET /api/contratos?situacao=PENDENTE_ASSINATURA.
 * Drill-down: orcamentos aprovados (M-PED-3: /comercial/contratos
 * nunca existiu — o link caia no catch-all).
 */
import React from "react";
import { Link } from "react-router-dom";

import { listarContratos } from "../../../services/contratos";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "contratos_pendentes",
  label: "Contratos pendentes",
  descricao: "Contratos aguardando assinatura do cliente (link público).",
  categoria: "Pendencias",
  permissoes: ["contrato:view"],
  tamanho_default: "S",
  essencial: true,
};

export async function fetchData(request) {
  const payload = await listarContratos(request, {
    situacao: "PENDENTE_ASSINATURA",
    pageSize: 5,
  });
  // payload pode ser lista direta OU {results, count}
  if (Array.isArray(payload)) {
    return { count: payload.length, items: payload.slice(0, 3) };
  }
  return {
    count: payload?.count ?? (payload?.results || []).length,
    items: (payload?.results || []).slice(0, 3),
  };
}

export function Widget({ dados }) {
  const count = dados?.count ?? 0;
  return (
    <>
      <CardBody>
        <KpiValor>{count}</KpiValor>
        <KpiSub>
          {count === 0 ? "Nenhum contrato pendente." : "aguardando assinatura"}
        </KpiSub>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/orcamentos?situacao=APROVADO">Ver orçamentos aprovados</LinkLight>
      </CardFooter>
    </>
  );
}
